export interface NetworkBrandTheme {
  panel: string;
  muted: string;
  button: string;
  focus: string;
}

export interface NetworkBrand {
  key: "megastore" | "bolmart" | "grandmart" | "novashome";
  name: string;
  logo: string;
  descriptionKey: string;
  link: string;
  tagKey: "est2010" | "nearly20" | "insideStores";
  stat: { prefix: string; value: number; suffix: string };
  statLabelKey: "stores" | "branches" | "started";
  theme: NetworkBrandTheme;
}

const LIGHT_FOCUS = "focus-visible:outline-brand-navy";

export const NETWORK_BRANDS: NetworkBrand[] = [
  {
    key: "megastore",
    name: "Megastore",
    logo: "/Megastore.svg",
    descriptionKey: "megadescription",
    link: "https://www.megastore.market/",
    tagKey: "est2010",
    stat: { prefix: "", value: 21, suffix: "" },
    statLabelKey: "stores",
    theme: {
      panel: "bg-brand-navy text-brand-cream",
      muted: "text-brand-muted-dark",
      button: "bg-brand-cream text-brand-navy",
      focus: "focus-visible:outline-brand-cream",
    },
  },
  {
    key: "bolmart",
    name: "Bolmart",
    logo: "/Bolmart.svg",
    descriptionKey: "bolmartdescription",
    link: "https://www.bolmart.az/",
    tagKey: "nearly20",
    stat: { prefix: "~", value: 50, suffix: "" },
    statLabelKey: "branches",
    theme: {
      panel: "bg-brand-accent text-brand-navy",
      muted: "text-brand-navy",
      button: "bg-brand-navy text-brand-cream",
      focus: LIGHT_FOCUS,
    },
  },
  {
    key: "grandmart",
    name: "Grandmart",
    logo: "/Grandmart.svg",
    descriptionKey: "grandmartdescription",
    link: "https://www.grandmartsupermarket.com/",
    tagKey: "nearly20",
    stat: { prefix: "", value: 30, suffix: "+" },
    statLabelKey: "branches",
    theme: {
      panel: "bg-white text-brand-navy",
      muted: "text-brand-muted-light",
      button: "bg-brand-navy text-brand-cream",
      focus: LIGHT_FOCUS,
    },
  },
  {
    key: "novashome",
    name: "Novas Home",
    logo: "/Novashome.svg",
    descriptionKey: "novashomedescription",
    link: "https://www.novas-home.com/",
    tagKey: "insideStores",
    stat: { prefix: "", value: 2019, suffix: "" },
    statLabelKey: "started",
    theme: {
      panel: "bg-brand-panel-blue text-brand-navy",
      muted: "text-brand-muted-slate",
      button: "bg-brand-navy text-brand-cream",
      focus: LIGHT_FOCUS,
    },
  },
];
